import { ShadowField } from './shadowField.model';

export class DeviceShadow {
    id: string;
    fields: ShadowField[];
}
